import * as React from "react";
import {IBadgeCount} from "components/badges/BadgeGroup";

import './BadgeCount.pcss';

export const BadgeCount = (props:{badgeCount:IBadgeCount}) =>
<div className={'badge-count'}>
  <img src={props.badgeCount.badgeType.icon} alt={`${props.badgeCount.count} badge${props.badgeCount.count>1?"s":""} for ${props.badgeCount.badgeType.label}`}/>
  {props.badgeCount.count>1 && <div aria-hidden={true} className={'badge-count-text'}>{props.badgeCount.count}</div>}
</div>
;